export const DEFAULT_SHARE_DAYS = 14
export const MAX_SHARE_DAYS = 90
export const MAX_SHARE_PHOTOS = 400

const pad = (n: number) => (n < 10 ? '0' : '') + n

/** Local 'YYYY-MM-DD'. */
export const dateInputValue = (d: Date): string => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

const inDays = (now: Date, days: number) => dateInputValue(new Date(now.getFullYear(), now.getMonth(), now.getDate() + days))

export const defaultExpiryInput = (now: Date = new Date()): string => inDays(now, DEFAULT_SHARE_DAYS)
export const minExpiryInput = (now: Date = new Date()): string => inDays(now, 1)
export const maxExpiryInput = (now: Date = new Date()): string => inDays(now, MAX_SHARE_DAYS)

/** 'YYYY-MM-DD' (local) -> ISO instant at the end of that local day. */
export function expiryToIso(value: string): string {
  const [y, m, d] = value.split('-').map(Number)
  return new Date(y, m - 1, d, 23, 59, 59, 999).toISOString()
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function parseEmailList(raw: string): { emails: string[]; invalid: string[] } {
  const emails: string[] = []
  const invalid: string[] = []
  raw
    .split(/[\s,;]+/)
    .map((x) => x.trim().toLowerCase())
    .filter(Boolean)
    .forEach((x) => {
      const list = EMAIL.test(x) ? emails : invalid
      if (list.indexOf(x) < 0) list.push(x)
    })
  return { emails, invalid }
}

export const shareStatusVariant = (s: 'ACTIVE' | 'EXPIRED' | 'REVOKED'): 'success' | 'neutral' | 'danger' =>
  s === 'ACTIVE' ? 'success' : s === 'EXPIRED' ? 'neutral' : 'danger'

export const sharedPhotoDownloadUrl = (apiUrl: string, token: string, photoId: string): string =>
  `${apiUrl}/download/share/photos/${encodeURIComponent(token)}/photo/${encodeURIComponent(photoId)}`

export const sharedZipUrl = (apiUrl: string, token: string): string => `${apiUrl}/download/share/photos/${encodeURIComponent(token)}/zip`
